import {apiRequest} from "./client";
import type {CheckoutContext, County, PaymentCheckoutResponse, PaymentStatusResponse, PlaceOrderResponse, SavedAddress, SavedCompany} from "./types";

export async function getCheckoutContext(judet?: number, deliveryMethod = 50): Promise<CheckoutContext> {
  const params = new URLSearchParams();
  if(judet && judet > 0) params.set("judet", String(judet));
  if(deliveryMethod > 0) params.set("metodaLivrare", String(deliveryMethod));
  const q = params.toString();
  return apiRequest<CheckoutContext>(`/checkout/context${q ? `?${q}` : ""}`);
}

export async function enableGuestCheckout(): Promise<{guestMode: boolean}> {
  return apiRequest<{guestMode: boolean}>("/checkout/guest", {method: "POST"});
}

export async function cancelGuestCheckout(): Promise<{guestMode: boolean}> {
  return apiRequest<{guestMode: boolean}>("/checkout/guest/cancel", {method: "POST"});
}

export async function getCheckoutAddress(id: number): Promise<Omit<SavedAddress, "id" | "nume">> {
  return apiRequest<Omit<SavedAddress, "id" | "nume">>(`/checkout/addresses/${id}`);
}

export async function getCheckoutCompany(id: number): Promise<Omit<SavedCompany, "id">> {
  return apiRequest<Omit<SavedCompany, "id">>(`/checkout/companies/${id}`);
}

export async function placeOrder(data: Record<string, string | number>): Promise<PlaceOrderResponse> {
  return apiRequest<PlaceOrderResponse>("/orders", {method: "POST", body: data});
}

export async function createPaymentCheckout(data: {orderId?: number; hash?: string}): Promise<PaymentCheckoutResponse> {
  return apiRequest<PaymentCheckoutResponse>("/payment/checkout", {method: "POST", body: data});
}

export async function getPaymentStatus(orderId: number): Promise<PaymentStatusResponse> {
  return apiRequest<PaymentStatusResponse>(`/payment/orders/${orderId}`);
}

export type {County};
